import React from "react";
import Routers from "./Routers";
import AuthenticateProvider from "./Contexts/AuthenticateProvider";
import { ToastContainer } from "react-toastify";

function App() {
  return (
    <React.Fragment>
      <AuthenticateProvider>
        <Routers />
      </AuthenticateProvider>
      <ToastContainer theme="light" toastStyle={{ textTransform: 'capitalize' }} autoClose={2000} position="top-right" />
    </React.Fragment>
  );
}

export default App;